import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import {
    TwEnvioMuestraLaboratorioSolicitudExViewModel,
    EnvioMuestrasLaboratorioSolicitudExInspectorViewModel,
    MotivoMuestraLaboratorioSolicitudExViewModel,
    MotivoMuestraLaboratorioExViewModel,
    ResultadoEnvioMuestraLaboratorioExViewModel,
    SolicitudLaboratorioExViewModel,
    TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel,
    DocumentoMuestraLaboratorioSolicitudExViewModel,
    TwTcResultadoEnvioMuestraLaboratorioExEnum,
} from '../laboratorioEx.types';
import { LaboratorioExService } from '../laboratorioEx.service';
import { RegLaboratorioViewModel } from '../../../../_mantenimiento/registros/laboratorios/laboratorio.types';
import { RegLaboratorioService } from '../../../../_mantenimiento/registros/laboratorios/laboratorio.service';
import { TProductoSolicitudExViewModel, TwEmbalajesExViewModel } from '../../productos/productosEx.types';
import { TcPerfilUsuarioEnum } from '../../../../core/_infrastructure/types/common';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../../../../_importacion/solicitudes/types/enum';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { SolicitudExService } from '../../datosbasicos/datosbasicosEx.service';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../../types/enum';

@Component({
    selector: 'app-laboratorioex-wrapper',
    templateUrl: './laboratorioex-wrapper.component.html',
})
export class LaboratorioExWrapperComponent extends ComponentBase implements OnInit {
    public isCollapsedCabecera = false;
    visibilitySpinner = false;

    private successMessageInspector = 'Envío de muestras a laboratorio realizado correctamente';
    private successMessageLaboratorio = 'Resultado de muestras enviado correctamente';

    IdTipoSolicitudEx: number;
    IdEstadoSolicitudEx: number;
    IdEstadoCertificadoFitoEx: number;
    TituloTipoSolicitudEx: string;
    CodigoTipoSolicitud: string;
    TituloEstadoSolicitudEx: string;
    TituloEstadoCertificadoFitoEx: string;
    esClonada = false;

    habilitarEnvioMuestrasEx = false;

    motivosSeleccionadosEx: MotivoMuestraLaboratorioSolicitudExViewModel[];
    productosSeleccionadosEx: TProductoSolicitudExViewModel[];
    embalajesSeleccionadosEx: TwEmbalajesExViewModel[];

    /*Inputs()*/
    idSolicitudEx = 0;
    solicitudLaboratorioEx: SolicitudLaboratorioExViewModel;
    usuarioId: number | undefined;
    usuarioIdDescripcion = '';
    usuarioAsociadoEnvioId: number | null;
    usuarioAsociadoEnvioDescripcion = '';
    formGroup: FormGroup;
    listLaboratorios: RegLaboratorioViewModel[];
    listMotivosEx: MotivoMuestraLaboratorioExViewModel[];
    listProductosEx: TProductoSolicitudExViewModel[];
    listEmbalajesEx: TwEmbalajesExViewModel[];
    listResultadosEx: ResultadoEnvioMuestraLaboratorioExViewModel[];
    listMotivosSolicitudEx: MotivoMuestraLaboratorioSolicitudExViewModel[];
    esPerfilInspector = false;
    esPerfilConsultasyLaboratorio = false;
    hayEnvioMuestrasInspectorEx = false;
    envioMuestrasEx: TwEnvioMuestraLaboratorioSolicitudExViewModel;
    enviandoMuestrasEx = false;
    hayResultadoMuestrasLaboratorioEx = false;
    resultadoMuestrasLaboratorioEx: TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel;
    envioMuestrasExCerrado = false;
    documentosLaboratorioEx: DocumentoMuestraLaboratorioSolicitudExViewModel[];

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const idSolicitudEx = params.get('id');
        if (idSolicitudEx) {
            this.idSolicitudEx = parseInt(idSolicitudEx);

            if (this.idSolicitudEx) {
                this.inicializarDatosLaboratorioEx();
            }
        }
    });

    constructor(
        protected notificationService: NotificationService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router,
        private laboratorioExService: LaboratorioExService,
        private regLaboratorioService: RegLaboratorioService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    private inicializarDatosLaboratorioEx() {
        this.getSolicitudLaboratorioEx();
        this.getMotivosMuestraLaboratorioByIdSolicitudEx();
        this.getDocumentosSolicitudLaboratorioEx();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    ngOnInit(): void {
        this.esPerfilInspector = this.isInspector;
        this.esPerfilConsultasyLaboratorio =
            this.isConsultas && this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Laboratorio);

        this.usuarioId = this.loggedInUser?.Id;
        this.usuarioIdDescripcion = `${this.loggedInUser?.Nombre} ${this.loggedInUser?.Apellidos}`;

        this.guardRefreshPage(this.idSolicitudEx);

        this.buildForm();

        this.getAllLaboratoriosActivos();

        this.getListMotivosMuestraLaboratorioEx();

        this.getListResultadosMuestraLaboratorioEx();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                IdSolicitudEx: this.idSolicitudEx, //Not visible
                /*Datos del laboratorio*/
                IdLaboratorio: [null, Validators.required],
                IdLaboratorioEnvioMuestrasSolicitudEx: [null, Validators.required],
                IdUsuario: [null, Validators.required],
                IdUsuarioDescripcion: ['', Validators.required],
                FechaEnvio: null,
                ObservacionesEnvio: '',
                /*Envío de muestras*/
                IdMotivoEx: null,
                IdProductoEx: null,
                IdEmbalajeEx: null,
                /*Resultado de muestras*/
                IdResultadoEx: [null, Validators.required],
                IdTecnico: [null, Validators.required],
                IdTecnicoDescripcion: '',
                FechaResultado: null,
                ObservacionesResultado: '',
            }),
        });
    }

    onBack() {
        this.enviandoMuestrasEx = false;
    }

    getAllLaboratoriosActivos() {
        this.regLaboratorioService.getAllLaboratoriosActivos().subscribe(res => {
            this.listLaboratorios = res;
        });
    }

    getListMotivosMuestraLaboratorioEx() {
        this.laboratorioExService.getMotivosMuestraLaboratorioEx().subscribe(res => {
            this.listMotivosEx = res;
        });
    }

    getMotivosMuestraLaboratorioByIdSolicitudEx() {
        this.laboratorioExService.getMotivosMuestraLaboratorioByIdSolicitudEx(this.idSolicitudEx).subscribe(res => {
            this.listMotivosSolicitudEx = res;
        });
    }

    getListResultadosMuestraLaboratorioEx() {
        this.laboratorioExService.getResultadosMuestraLaboratorioEx().subscribe(res => {
            this.listResultadosEx = res;
        });
    }

    getSolicitudLaboratorioEx() {
        this.loading = true;
        this.laboratorioExService.getSolicitudLaboratorioEx(this.idSolicitudEx).subscribe(res => {
            this.loading = false;
            this.solicitudLaboratorioEx = res;
            this.IdTipoSolicitudEx = this.solicitudLaboratorioEx.IdTipoSolicitudEx;
            this.IdEstadoSolicitudEx = this.solicitudLaboratorioEx.IdEstadoSolicitudEx;
            this.IdEstadoCertificadoFitoEx = this.solicitudLaboratorioEx.IdEstadoCertificadoFitoEx;
            this.TituloTipoSolicitudEx = this.solicitudLaboratorioEx.IdTipoSolicitudExDescripcion;
            this.esClonada =
                this.solicitudLaboratorioEx.TwSolicitudJerarquiaEx != null &&
                this.solicitudLaboratorioEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            //Si es previa
            if (this.solicitudLaboratorioEx.EsPrevia) {
                if (
                    this.solicitudLaboratorioEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                    this.solicitudLaboratorioEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                ) {
                    this.TituloTipoSolicitudEx += '-Previa';
                }
            }
            this.CodigoTipoSolicitud = this.solicitudLaboratorioEx.CodigoTipoSolicitud;
            this.TituloEstadoSolicitudEx = this.solicitudLaboratorioEx.IdEstadoSolicitudExDescripcion;
            this.TituloEstadoCertificadoFitoEx = this.solicitudLaboratorioEx.IdEstadoCertificadoFitoExDescripcion;

            this.listProductosEx = this.solicitudLaboratorioEx.TProductoSolicitudExCollection;
            this.listEmbalajesEx = this.solicitudLaboratorioEx.TwEmbalajesExCollection;
            this.solicitudLaboratorioEx.TwTcMotivoMuestraLaboratorioExCollection = this.listMotivosEx;
            this.solicitudLaboratorioEx.TwMotivoMuestraLaboratorioExCollection = this.listMotivosSolicitudEx;

            this.envioMuestrasEx = res.TwEnvioMuestraLaboratorioSolicitudEx;
            this.resultadoMuestrasLaboratorioEx = res.TwResultadoEnvioMuestraLaboratorioSolicitudEx;

            if (this.envioMuestrasEx) {
                this.enviandoMuestrasEx = false;
                this.hayEnvioMuestrasInspectorEx = true;

                this.usuarioAsociadoEnvioId = this.envioMuestrasEx.IdUsuario;
            }

            if (this.resultadoMuestrasLaboratorioEx) {
                if (this.resultadoMuestrasLaboratorioEx.IdTecnico != null && this.resultadoMuestrasLaboratorioEx.FechaResultado != null) {
                    this.hayResultadoMuestrasLaboratorioEx = true;
                }
                if (
                    this.hayResultadoMuestrasLaboratorioEx &&
                    (this.resultadoMuestrasLaboratorioEx.IdResultadoEx == TwTcResultadoEnvioMuestraLaboratorioExEnum.Aceptada ||
                        this.resultadoMuestrasLaboratorioEx.IdResultadoEx == TwTcResultadoEnvioMuestraLaboratorioExEnum.Rechazada)
                ) {
                    this.envioMuestrasExCerrado = true;
                }
            }

            this.habilitarEnvioMuestrasEx = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.ENVIO_MUESTRAS_SOLICITUD_EXPORTACION,
                this.solicitudLaboratorioEx.IdEstadoSolicitudEx,
            ).Visible;
        });
    }

    onEnvioMuestrasEx(): void {
        this.confirmationService.confirm({
            message: '¿Está seguro? Se iniciará el proceso de envío de muestras a laboratorio.',
            accept: () => {
                this.enviandoMuestrasEx = true;
            },
        });
    }

    onAddMotivosExSelected(motivosEx: MotivoMuestraLaboratorioSolicitudExViewModel[]): void {
        this.motivosSeleccionadosEx = motivosEx;
    }

    onAddProductosExSelected(productosEx: TProductoSolicitudExViewModel[]): void {
        this.productosSeleccionadosEx = productosEx;
    }

    onAddEmbalajesExSelected(embalajesEx: TwEmbalajesExViewModel[]): void {
        this.embalajesSeleccionadosEx = embalajesEx;
    }

    onSaveEnvioMuestrasInspectorEx(): void {
        if (this.esPerfilInspector) {
            const model = { ...this.formGroup.value.basic };

            let inspectorEnvioMuestrasExModel = new EnvioMuestrasLaboratorioSolicitudExInspectorViewModel();

            inspectorEnvioMuestrasExModel.TwEnvioMuestraLaboratorioSolicitudEx.IdSolicitudEx = this.idSolicitudEx;
            inspectorEnvioMuestrasExModel.TwEnvioMuestraLaboratorioSolicitudEx.IdLaboratorio = model.IdLaboratorio;
            inspectorEnvioMuestrasExModel.TwEnvioMuestraLaboratorioSolicitudEx.IdUsuario = model.IdUsuario;
            inspectorEnvioMuestrasExModel.TwEnvioMuestraLaboratorioSolicitudEx.FechaEnvio = new Date();
            inspectorEnvioMuestrasExModel.TwEnvioMuestraLaboratorioSolicitudEx.ObservacionesEnvio = model.ObservacionesEnvio;

            inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.IdSolicitudEx = this.idSolicitudEx;
            inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.MotivosExCollection = this.motivosSeleccionadosEx;
            inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.ProductosExCollection = this.productosSeleccionadosEx;
            inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.EmbalajesExCollection = this.embalajesSeleccionadosEx;

            inspectorEnvioMuestrasExModel.TwResultadoEnvioMuestraLaboratorioSolicitudEx.IdSolicitudEx = this.idSolicitudEx;
            inspectorEnvioMuestrasExModel.TwResultadoEnvioMuestraLaboratorioSolicitudEx.IdResultadoEx = TwTcResultadoEnvioMuestraLaboratorioExEnum.Pendiente;
            inspectorEnvioMuestrasExModel.TwResultadoEnvioMuestraLaboratorioSolicitudEx.IdTecnico = null;
            inspectorEnvioMuestrasExModel.TwResultadoEnvioMuestraLaboratorioSolicitudEx.FechaResultado = null;
            inspectorEnvioMuestrasExModel.TwResultadoEnvioMuestraLaboratorioSolicitudEx.ObservacionesResultado = '';

            if (!inspectorEnvioMuestrasExModel.TwEnvioMuestraLaboratorioSolicitudEx.IdLaboratorio) {
                this.addErrorMessage('Debe añadir un laboratorio');
                return;
            }
            if (
                inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.MotivosExCollection == undefined ||
                inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.MotivosExCollection.length == 0
            ) {
                this.addErrorMessage('Debe añadir un motivo');
                return;
            }
            if (
                (inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.ProductosExCollection == undefined ||
                    inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.ProductosExCollection.length == 0) &&
                (inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.EmbalajesExCollection == undefined ||
                    inspectorEnvioMuestrasExModel.TwMotivoMuestraLaboratorioSolicitudEx.EmbalajesExCollection.length == 0)
            ) {
                this.addErrorMessage('Debe añadir al menos un producto o un embalaje');
                return;
            }

            this.confirmationService.confirm({
                message: '¿Está seguro? Una vez se hayan enviado las muestras no será posible su modificación.',
                accept: () => {
                    this.laboratorioExService.saveInspectorEnvioMuestrasEx(inspectorEnvioMuestrasExModel).subscribe({
                        next: () => {
                            this.addSuccessMessage(this.successMessageInspector);
                            this.inicializarDatosLaboratorioEx();
                        },
                        error: error => {
                            this.catchServerError(error);
                            this.visibilitySpinner = false;
                        },
                    });
                },
            });
        }
    }

    onSaveResultadoEnvioMuestrasLaboratorioEx(): void {
        if (this.esPerfilConsultasyLaboratorio) {
            const model = { ...this.formGroup.value.basic };
            let laboratorioResultadoEnvioMuestrasExModel = new TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel();

            laboratorioResultadoEnvioMuestrasExModel.IdSolicitudEx = this.idSolicitudEx;
            laboratorioResultadoEnvioMuestrasExModel.IdResultadoEx = model.IdResultadoEx;
            laboratorioResultadoEnvioMuestrasExModel.IdTecnico = model.IdTecnico;
            laboratorioResultadoEnvioMuestrasExModel.FechaResultado = new Date();
            laboratorioResultadoEnvioMuestrasExModel.ObservacionesResultado = model.ObservacionesResultado;

            // A pesar de que se envía el array de documentos, no se procesa en el core.
            laboratorioResultadoEnvioMuestrasExModel.TwDocumentoMuestraLaboratorioSolicitudExCollection = this.documentosLaboratorioEx;

            if (
                laboratorioResultadoEnvioMuestrasExModel.IdResultadoEx == TwTcResultadoEnvioMuestraLaboratorioExEnum.Aceptada ||
                laboratorioResultadoEnvioMuestrasExModel.IdResultadoEx == TwTcResultadoEnvioMuestraLaboratorioExEnum.Rechazada
            ) {
                this.confirmationService.confirm({
                    message: '¿Está seguro? Una vez se haya cerrado el envío de muestras a laboratorio no será posible su modificación.',
                    accept: () => {
                        this.laboratorioExService.saveResultadoEnvioMuestrasLaboratorioEx(laboratorioResultadoEnvioMuestrasExModel).subscribe({
                            next: () => {
                                this.addSuccessMessage(this.successMessageLaboratorio);
                                this.visibilitySpinner = false;
                                this.inicializarDatosLaboratorioEx();
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.visibilitySpinner = false;
                            },
                        });
                    },
                });
            } else {
                this.laboratorioExService.saveResultadoEnvioMuestrasLaboratorioEx(laboratorioResultadoEnvioMuestrasExModel).subscribe({
                    next: () => {
                        this.addSuccessMessage(this.successMessageLaboratorio);
                        this.visibilitySpinner = false;
                        this.inicializarDatosLaboratorioEx();
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                    },
                });
            }
        }
    }

    onAddDocumentoEx() {
        this.router.navigate([`/exportacion/solicitud/laboratorioEx/${this.idSolicitudEx}/documento`]);
    }

    getDocumentosSolicitudLaboratorioEx(): void {
        this.laboratorioExService.getDocumentosLaboratorio(this.idSolicitudEx).subscribe(res => {
            this.documentosLaboratorioEx = res;
        });
    }

    onDownloadDoc(doc: DocumentoMuestraLaboratorioSolicitudExViewModel): void {
        this.laboratorioExService.download(doc).subscribe(res => this.OpenDownloadedFile(res));
    }

    onRemoveDoc(doc: DocumentoMuestraLaboratorioSolicitudExViewModel): void {
        if (!doc) {
            return;
        }
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.laboratorioExService.deleteDocumentosLaboratorio(doc.Id!).subscribe(() => {
                    this.addSuccessMessage('Documento eliminado correctamente');
                    this.getDocumentosSolicitudLaboratorioEx();
                });
            },
        });
    }

    get siTieneAtestacion(): boolean {
        return (
            this.solicitudLaboratorioEx?.IdSubTipoSolicitudEx === EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO ||
            this.solicitudLaboratorioEx?.IdSubTipoSolicitudEx === EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO ||
            this.solicitudLaboratorioEx?.IdSubTipoSolicitudEx === EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO
        );
    }
}
